import axios from 'axios';
import ORBITVUSUN from './gallery/orbitvu-sun-public-gallery';
import getPresentationData from './getPresentationData';

ORBITVUSUN.namespace('injectGallery');
ORBITVUSUN.injectGallery = (shopify, product, ajaxUrl) => {
    const shopDomain = shopify.shop,
          productId = product.id;


    const properImages = [...product.ovImages];

    for (let media of product.media) {
        if (media.media_type === "external_video" || media.media_type === "video") {
            const dataToInsert = {
                id: media.id,
                title: media.alt,
                type: media.media_type,
                host: media.host,
                external_id: media.external_id,
                preview_image: media.preview_image,
                source: media.sources
            }
            properImages.splice(media.position, 0, dataToInsert);
        }
    }



    axios.post('https://' + ajaxUrl + '/front/gallery/' + shopDomain + '/' + productId, {
            variants: product.variants,
            images: properImages,
        })
        .then((response) => {
            let wrapper = document.getElementById('ovgallery-wrapper'),
                scripts = response.data.scripts,
                scriptsLoadedCounter = 0,
                settings = response.data.settings;

            //inject scripts
            for(let scriptUrl of scripts) {
                let script = document.createElement('script');
                script.onload = function() {
                    scriptsLoadedCounter++;
                };
                script.src = scriptUrl;
                document.getElementsByTagName('head')[0].appendChild(script);
            }

            const injectGallery = () => {
                setTimeout(function() {
                    if (scriptsLoadedCounter >= scripts.length) {
                        wrapper.innerHTML = response.data.html;
                        let ovData = getPresentationData(response.data.items, settings);
                        ORBITVUSUN.gallery.init({
                            presentationData: ovData,
                            thumbs: {
                                scrollEnabled: settings.gallery.scroll === 'yes' ? 1 : 0,
                                hoverDelay: settings.gallery.thumbnail_hover_delay,
                                orientation: settings.gallery.thumbs_orientation ? settings.gallery.thumbs_orientation : "horizontal",
                            },
                            zoomMagnifier: {
                                enabled: settings.magnifier.zoom_magnifier_enabled !== 0 ? 1 : 0,
                                lensesVisible: settings.magnifier.zoom_magnifier_lenses,
                                maxZoomEnabled: settings.magnifier.zoom_magnifier_maxzoom_enabled,
                                maxZoomWidth: settings.magnifier.zoom_magnifier_maxzoom_width,
                                maxZoomHeight: settings.magnifier.zoom_magnifier_maxzoom_height,
                                proportions: settings.magnifier.zoom_magnifier_proportions ? settings.magnifier.zoom_magnifier_proportions : "auto",
                            },
                            gallery: {
                                imageSwipe: settings.gallery.image_swipe
                            },
                            lightbox: {
                                enabled: settings.lightbox.lightbox_enabled !== 0 ? 1 : 0,
                                colorizedBg: settings.lightbox.lightbox_colorized_bg,
                                backgroundColor: settings.lightbox.lightbox_background_color,
                                imageAutoSize: settings.lightbox.lightbox_image_auto_size,
                                thumbnailsEnabled: settings.lightbox.lightbox_thumbnails_enabled,
                                proportions: settings.lightbox.lightbox_proportions,
                                maxZoomEnabled: settings.lightbox.lightbox_maxzoom_enabled,
                                maxZoomWidth: settings.lightbox.lightbox_maxzoom_width,
                                maxZoomHeight: settings.lightbox.lightbox_maxzoom_height,
                            },
                            variants: product.variants, //Shopify specific
                        });
                    } else {
                        injectGallery();
                    }
                }, 50);
            };
            injectGallery();
        })
        .catch(error => {
            console.log(error);
            axios.post('https://' + ajaxUrl + '/front/galleryFallback/' + shopDomain + '/' + productId, {
            }).then((response) => {
                let wrapper = document.getElementById('ovgallery-wrapper');
                const injectFallbackGallery = () => {
                    wrapper.innerHTML = response.data.html;
                };
                injectFallbackGallery();
            });


        });


}
window.ORBITVUSUN = ORBITVUSUN;
